import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import {
  ManageReceiptTemplatesRootParamList,
  SettingsRootParamList,
} from "../../../../types";
import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import { ManageReceiptTemplatesScreen } from "./ManageReceiptTemplatesScreen";
import { EditReceiptTemplateScreen } from "./EditReceiptTemplateScreen";
import { CreateReceiptTemplateScreen } from "./CreateReceiptTemplateScreen";

const Stack = createStackHeaderNavigator<ManageReceiptTemplatesRootParamList>();

export interface ManageReceiptTemplatesRootScreenProps
  extends StackScreenProps<
    SettingsRootParamList,
    "ManageReceiptTemplatesRootScreen"
  > {}

export const ManageReceiptTemplatesRootScreen =
  ({}: ManageReceiptTemplatesRootScreenProps) => {
    return (
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        }}
      >
        <Stack.Group
          screenOptions={{
            title: "",
            headerLeft: () => <ModalCloseButton type="Back" />,
          }}
        >
          <Stack.Screen
            name="ManageReceiptTemplatesScreen"
            component={ManageReceiptTemplatesScreen}
          />
          <Stack.Screen
            name="EditReceiptTemplateScreen"
            component={EditReceiptTemplateScreen}
            options={{
              headerShown: false,
              title: "",
            }}
          />
          <Stack.Screen
            name="CreateReceiptTemplateScreen"
            component={CreateReceiptTemplateScreen}
            options={{
              headerShown: false,
              title: "",
            }}
          />
        </Stack.Group>
      </Stack.Navigator>
    );
  };
